import { TreeSelect } from 'antd';
import _ from 'lodash';
import React from 'react';
import { useNodeTree } from './NodeTree';
import { api, use, app } from 'xadmin';
import { getFormValues, useScriptVal } from './util'

export default props => {
  const multiple = false

  const { input, field, relateSchema = {} } = props
  const [value, setValue] = React.useState(undefined)
  const { loadData, onSearch, notFoundContent, children, nodes, ModelQuery } = useNodeTree(props, multiple, true, [],true)

  const ref = React.useRef()

  // 工作表字段脚本
  let values = getFormValues(relateSchema)
  React.useEffect(() => {
    if (relateSchema.fieldScript && values) {
      useScriptVal({ value: input.value, values, props, onChange })
    }
  }, [JSON.stringify(values)])

  const onChange = (node, label, extra) => {
    const { input: { onChange } } = props
    if (!node) {
      onChange(null)
    } else {
      const id = node.value ? node.value.slice(0, -37) : ''
      onChange({ id, name: node.label || '' })
    }
  }
  const placeholder = field && field.placeholder
  React.useEffect(() => {
    const value = input && input.value
    if (value) {
      if (_.isObject(value)) {
        setValue({ label: value.name || '', value: value.id || '' })
      }
      if (typeof value == 'string') {
        api('Node').get(value)
          .then(node => setValue({ label: node.name || '', value: node.id || '' }))
      }
    } else {
      setValue(undefined)
    }
  }, [input.value])

  const onDropdownVisibleChange = (v) => {
    if (v && !ref.current) {
      ModelQuery(field.model)
      ref.current = true
    }
  }

  return (
    <TreeSelect
      showLine
      treeIcon
      allowClear
      labelInValue
      value={value}
      showSearch={true}
      onChange={onChange}
      loadData={loadData}
      onSearch={onSearch}
      filterTreeNode={false}
      notFoundContent={notFoundContent}
      searchPlaceholder="输入资产名称或编号"
      style={{ minWidth: 160, width: '100%' }}
      onDropdownVisibleChange={onDropdownVisibleChange}
      dropdownStyle={{ maxHeight: 400, overflow: 'auto', width: '100%' }}
      placeholder={placeholder ? placeholder : '请选择资产'}
    // getPopupContainer={triggerNode => triggerNode.parentNode || document.body}
    >
      {children}
    </TreeSelect>
  )
}
